export const participantsOf = (list) => Object.keys(list.members);
export const userMembersOf = (trip) => Object.keys(trip.members).filter((id) => trip.members[id]?.kind === "user");
//# sourceMappingURL=trip.js.map